import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import firebase from 'firebase/compat/app';
import { filter, first, map } from 'rxjs/operators';
import { LearningService } from '../../../pages/app/learning/service/learning.service';
import { AssignmentService } from './services/assignment.service';
import { ModalController } from '@ionic/angular';
import { AddMemberModalComponent } from '../../add-member-modal/add-member-modal.component';
import { AllAssignmentsService } from 'src/app/pages/app/learning/assignments/services/all-assignments.service';
import { Observable, of } from 'rxjs';
import { RudderStack } from 'src/app/services';

@Component({
	selector: 'app-assignment',
	templateUrl: './assignment.component.html',
	styleUrls: ['./assignment.component.css'],
})
export class AssignmentComponent implements OnInit {
	@Input() data: any;
	@Input() isLock: boolean;

	selectedMembers = [];

	assignmentDetails$: Observable<any>;

	studentsList$;

	currentUser$: Observable<any>;
	buttonText: string;
	deleteText = 'Delete Submission';
	cohortId: number;

	constructor(
		private store: Store,
		private assignmentService: AssignmentService,
		private router: Router,
		private learningService: LearningService,
		public modalController: ModalController,
		private allAssignmentsService: AllAssignmentsService,
		private activatedRoute: ActivatedRoute,
		private rudderStack: RudderStack,
	) {}

	ngOnInit(): void {
		// this.learningService.loadStudentsInit(this.data.cohortId);
		// this.learningService.loadStudentsAPI(this.data.cohortId);

		this.activatedRoute.params
			.pipe(
				map(p => Number(p.cohortId)),
				filter(p => !!p),
			)
			.subscribe(cohortId => {
				this.allAssignmentsService.loadOtherAssignmentsInit(cohortId);
				this.cohortId = cohortId;
			});

		if (
			this.data.assignmentStatus === 'In progress' ||
			this.data.assignmentStatus === 'Unlocked' ||
			this.data.submissionId
		) {
			this.buttonText = 'Go to assignment';
		}
		if (this.data.assignmentStatus === 'Completed') {
			this.buttonText = 'View Submission';
		}
		this.assignmentDetails$ = this.assignmentService.getAssignmentDetailData(
			this.data.cohortId,
			this.data.id,
		);

		this.assignmentService
			.getAssignmentDetailAPI(this.data.cohortId, this.data.id)
			.subscribe();

		this.studentsList$ = this.learningService
			.loadStudentsData(this.data.cohortId)
			.pipe(
				filter(({ isSkeleton }) => !isSkeleton),
				map(({ data }: any) => {
					let loggedUserGroupId = data.filter(
						({ email }) => email === firebase.auth().currentUser?.email,
					)[0].groupId;
					return data.filter(({ groupId }) => groupId === loggedUserGroupId);
				}),
			);
		this.currentUser$ = this.learningService
			.loadStudentsData(this.data.cohortId)
			.pipe(
				filter(({ isSkeleton }) => !isSkeleton),
				map(({ data }: any): any => {
					return data.filter(
						({ email }) => email === firebase.auth().currentUser?.email,
					);
				}),
			);
	}

	redirectTo(url) {
		if (url) {
			window.open('https://textbook.terra.do/class/' + url, '_blank');
		}
	}

	membersUpdate(members, { id, assignmentGroupId }) {
		this.assignmentService
			.assignmentMemberAdd(
				id,
				assignmentGroupId,
				members.map(({ email }) => email),
			)
			.subscribe(() => {
				this.reloadData();
			});
	}

	leaveGroup({ id, assignmentGroupId, members }) {
		this.assignmentService
			.assignmentMemberAdd(
				id,
				assignmentGroupId,
				members
					.filter(({ email }) => email !== firebase.auth().currentUser?.email)
					.map(({ email }) => email),
			)
			.subscribe(() => {
				this.reloadData();
			});
	}

	mapId(ids) {
		return ids.map(({ id }) => id);
	}

	createAssignment() {
		this.assignmentService
			.createAssignment(this.data.id, firebase.auth().currentUser?.email, '')
			.subscribe(data => {
				if (data?.message) {
					// this.buttonText = 'Go to assignment';
					this.reloadData();
					// this.deleteText = 'Delete Assignment';
					this.data.submissionId = data.submissionId;

					this.learningService.editState(
						'assignment',
						this.cohortId,
						this.data.id,
						'id',
						'assignmentStatus',
						'In progress',
					);
					this.learningService.editState(
						'assignment',
						this.cohortId,
						this.data.id,
						'id',
						'submissionId',
						this.data.submissionId,
					);

					this.viewAssignment();
				}

				// this.reloadData();
			});
	}

	deleteAssignment() {
		this.assignmentService
			.deleteAssignment(this.data.id, firebase.auth().currentUser?.email)
			.subscribe(data => {
				if (data?.message) {
					localStorage.removeItem('assignmentId');
					this.learningService.editState(
						'assignment',
						this.cohortId,
						this.data.id,
						'id',
						'assignmentStatus',
						'Unlocked',
					);
				}
				this.reloadData();
			});
	}

	viewAssignment() {
		const tempUrl = window.location.href;
		if(this.buttonText == 'Go to assignment' && this.router.url.includes('my-schedule')){
			this.rudderStack.log({
				type: 'assignment_view_click',
				cohortId: this.cohortId,
				assignmentId: this.data.id,
				name: this.data.name
			});
		}
		this.router.navigate([
			`/app/learning/${this.data.cohortId}/assignments/assignment-id/${this.data.id}`,
		]);
	}

	getInspired() {
		this.rudderStack.log({
			type: 'assignment_get_inspired',
			cohortId: this.cohortId,
			assignmentId: this.data.id,
			name: this.data.name
		});
		this.allAssignmentsService.loadMoreOtherAssignmentsSetFilter(
			this.cohortId,
			{
				assignment: this.data.id,
			},
		);

		this.router.navigate([
			`/app/learning/${this.data.cohortId}/assignments/other`,
		]);
	}
	reloadData() {
		this.assignmentService.getAssignmentDetailReset(
			this.data.cohortId,
			this.data.id,
		);
		this.assignmentService
			.getAssignmentDetailAPI(this.data.cohortId, this.data.id)
			.subscribe(() => {});
	}
	public async openAddMemberModal() {
		this.studentsList$.pipe(first()).subscribe(studentList => {
			this.assignmentDetails$.pipe(first()).subscribe(async assignment => {
				const modal = await this.modalController.create({
					component: AddMemberModalComponent,
					cssClass: 'add-group-member-modal-class',
					componentProps: {
						studentList,
						assignmentGroup: assignment.data[0],
						cohortId: this.cohortId
					},
				});
				modal.onDidDismiss().then(flag => {
					const data = flag;
					if (data.data && data.data.flag === true) {
						this.reloadData();
						this.assignmentService
							.getAssignmentDetailAPI(this.data.cohortId, this.data.id)
							.subscribe();
					}
				});
				modal.style.cssText = `--max-width: 690px;--min-width: 690px;`;
				return await modal.present();
			});
		});
	}
}
